import styled from "@xstyled/styled-components";
import TailwindTheme from "../../theme/TailwindTheme";
import { Button } from "antd";

const DarkButton = styled(Button)`
    background-color: ${TailwindTheme.colors.gray[700]};
    border-color: ${TailwindTheme.colors.gray[700]};
    color: white;
    :hover {
        background-color: ${TailwindTheme.colors.gray[600]};
        border-color: ${TailwindTheme.colors.gray[600]};
        color: white;
    }
    :focus {
        background-color: ${TailwindTheme.colors.gray[700]};
        border-color: ${TailwindTheme.colors.gray[700]};
        color: white;
    }
    :active {
        background-color: ${TailwindTheme.colors.gray[800]};
        border-color: ${TailwindTheme.colors.gray[800]};
        color: white;
    }
`;

export default DarkButton;